export default function SoftwareUpdateCatalogPicker({
  iosCatalog = [],
  macCatalog = [],
  value,
  onChange,
  loading = false,
  error = "",
  onRetry,
  name = "su-version",
}) {
  if (loading) {
    return <p className="text-muted mb-0">Lade Apple GDMF-Katalog…</p>;
  }

  if (error) {
    return (
      <div>
        <p className="text-danger mb-2">{error}</p>
        {onRetry ? (
          <button type="button" className="btn btn-outline-secondary btn-sm" onClick={onRetry}>
            Erneut laden
          </button>
        ) : null}
      </div>
    );
  }

  const sections = [
    ["iOS / iPadOS / tvOS", iosCatalog],
    ["macOS", macCatalog],
  ];

  return (
    <div>
      <label className="form-check mb-3">
        <input
          type="radio"
          className="form-check-input"
          name={name}
          checked={!value}
          onChange={() => onChange(null)}
        />
        <span className="form-check-label">Kein OS-Update über DDM</span>
      </label>
      {sections.map(([label, rows]) => (
        <div key={label} className="mb-3">
          <h6>{label}</h6>
          {rows.length === 0 ? (
            <p className="small text-muted">Keine Versionen in diesem Katalog.</p>
          ) : (
            <div className="d-flex flex-column gap-1" style={{ maxHeight: 280, overflow: "auto" }}>
              {rows.map((item) => (
                <label key={item.identifier} className="form-check">
                  <input
                    type="radio"
                    className="form-check-input"
                    name={name}
                    checked={value === item.identifier}
                    onChange={() => onChange(item.identifier)}
                  />
                  <span className="form-check-label">
                    {item.productVersion}
                    {item.build ? <span className="text-muted"> · {item.build}</span> : null}
                    {item.postingDate ? <span className="small text-muted"> · {item.postingDate}</span> : null}
                  </span>
                </label>
              ))}
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
